import React from "react";
import * as Unicons from '@iconscout/react-unicons';
import { Link } from "react-router-dom";

export default function GetInTouch() {
    return (
        <section className="relative md:py-24 py-16 bg-gray-50 dark:bg-slate-800" id="contact">
            <div className="container">
                <div className="grid grid-cols-1 pb-8 text-center">
                    <h3 className="mb-6 md:text-2xl text-xl md:leading-normal leading-normal font-semibold">
                        Get In Touch !
                    </h3>

                    <p className="text-slate-400 max-w-xl mx-auto text-[15px]">
                        Contact for further information
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-12 md:grid-cols-2 mt-8 items-center gap-[30px]">
                    {/* CONTACT FORM */}
                    <div className="lg:col-span-8">
                        <div className="p-6 rounded-md shadow bg-white dark:bg-slate-900">
                            <form>
                                <div className="grid lg:grid-cols-12 lg:gap-5">
                                    <div className="lg:col-span-6 mb-5">
                                        <input
                                            name="name"
                                            id="name"
                                            type="text"
                                            className="form-input w-full py-2 px-3 border border-inherit dark:border-gray-800 dark:bg-slate-900 dark:text-slate-200 rounded h-10 outline-none bg-transparent focus:border-amber-500/50"
                                            placeholder="Name :"
                                        />
                                    </div>

                                    <div className="lg:col-span-6 mb-5">
                                        <input
                                            name="email"
                                            id="email"
                                            type="email"
                                            className="form-input w-full py-2 px-3 border border-inherit dark:border-gray-800 dark:bg-slate-900 dark:text-slate-200 rounded h-10 outline-none bg-transparent focus:border-amber-500/50"
                                            placeholder="Email :"
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1">
                                    <div className="mb-5">
                                        <input
                                            name="subject"
                                            id="subject"
                                            className="form-input w-full py-2 px-3 border border-inherit dark:border-gray-800 dark:bg-slate-900 dark:text-slate-200 rounded h-10 outline-none bg-transparent focus:border-amber-500/50"
                                            placeholder="Subject :"
                                        />
                                    </div>

                                    <div className="mb-5">
                                        <textarea
                                            name="comments"
                                            id="comments"
                                            className="form-input w-full py-2 px-3 border border-inherit dark:border-gray-800 dark:bg-slate-900 dark:text-slate-200 rounded h-28 outline-none bg-transparent focus:border-amber-500/50"
                                            placeholder="Message :"
                                        ></textarea>
                                    </div>
                                </div>

                                <button
                                    type="submit"
                                    id="submit"
                                    name="send"
                                    className="btn bg-amber-500 hover:bg-amber-600 border-amber-500 hover:border-amber-600 text-white rounded-md h-11 justify-center flex items-center"
                                >
                                    Send Message
                                </button>
                            </form>
                        </div>
                    </div>

                    {/* CONTACT DETAILS */}
                    <div className="lg:col-span-4">
                        <div className="lg:ms-8">

                            {/* LINKEDIN */}
                            <div className="flex">
                                <div className="icons text-center mx-auto">
                                    <a
                                        href="https://www.linkedin.com/in/pramod-john-099a0327/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <Unicons.UilLinkedin className="block rounded text-2xl dark:text-white mb-0 cursor-pointer" />
                                    </a>
                                </div>

                                <div className="flex-1 ms-6">
                                    <h5 className="text-[17px] dark:text-white mb-2 font-medium">LinkedIn</h5>

                                    <a
                                        href="https://www.linkedin.com/in/pramod-john-099a0327/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-slate-400 text-[15px]"
                                    >
                                        Pramod John
                                    </a>
                                </div>
                            </div>

                            {/* EMAIL */}
                            <div className="flex mt-4">
                                <div className="icons text-center mx-auto">
                                    <Unicons.UilEnvelope className=" block rounded text-2xl dark:text-white mb-0" />
                                </div>

                                <div className="flex-1 ms-6">
                                    <h5 className="text-[17px] dark:text-white mb-2 font-medium">Email</h5>

                                    <a
                                        href="mailto:pramod.john@demetrix.in"
                                        className="text-slate-400 text-[15px]"
                                    >
                                        pramod.john@demetrix.in
                                    </a>
                                </div>
                            </div>

                            {/* LOCATION */}
                            {/* <div className="flex mt-4">
                                <div className="icons text-center mx-auto">
                                    <Unicons.UilMapMarker className=" block rounded text-2xl dark:text-white mb-0" />
                                </div>

                                <div className="flex-1 ms-6">
                                    <h5 className="text-[17px] dark:text-white mb-2 font-medium">Location</h5>
                                    <p className="text-slate-400 text-[15px] mb-2">
                                        #401, 4th Floor, HVS Court, Cunningham Road, Bangalore, Karnataka - 560052
                                    </p>
                                </div>
                            </div> */}

                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}
